module.exports = __webpack_public_path__ + "img/no-data-report.902f6598.png";